import { useEffect, useState } from 'react';
import { useInterval } from './use_interval';

const TICK_INTERVAL_MS = 1000;

/**
 * Milliseconds since `since` on the local clock, re-derived once a second.
 */
export function useElapsedTime(since: number | undefined): number | undefined {
  const [now, setNow] = useState(Date.now);

  // Re-anchor when measurement (re)starts; `now` may be stale from a disabled stretch.
  useEffect(() => {
    if (since !== undefined) setNow(Date.now());
  }, [since]);

  useInterval(() => setNow(Date.now()), since === undefined ? null : TICK_INTERVAL_MS);

  return since === undefined ? undefined : Math.max(0, now - since);
}
